// extracted by mini-css-extract-plugin
export default {"wrapper":"Alert_wrapper__maoXC","title":"Alert_title__NjJ-f","stage":"Alert_stage__tLWHC"};